var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 270,
    viewBox: "0 0 313 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_949",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 313,
    height: 270
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.459961 0.498047H312.46V269.482H0.459961V0.498047Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.642 23.7168C258.715 -7.21029 208.174 -7.21029 177.325 23.7168L156.679 44.3626L136.033 23.7168C105.106 -7.21029 54.5642 -7.21029 23.7152 23.7168C-6.26394 53.696 -7.13373 102.186 21.0277 133.269H93.7152L104.314 77.9772C104.793 75.3678 107.007 73.472 109.694 73.3105C112.382 73.1543 114.757 74.8939 115.47 77.4251L141.335 165.462L155.413 108.274C156.049 105.821 158.184 104.003 160.715 103.925C163.246 103.764 165.538 105.347 166.408 107.8L177.403 139.045L197.653 77.2689C198.444 74.8939 200.736 73.2324 203.267 73.3105C205.799 73.3939 208.012 75.0553 208.648 77.5033L224.069 133.269H292.335C320.569 102.186 319.621 53.696 289.642 23.7168ZM214.106 140.545L202.559 98.9408L182.939 158.738C182.148 161.113 180.012 162.696 177.559 162.696H177.481C175.033 162.696 172.892 161.191 172.023 158.816L161.819 129.79L147.267 188.873C146.632 191.404 144.418 193.227 141.809 193.227H141.653C139.121 193.227 136.825 191.566 136.116 189.113L111.038 103.368L104.002 140.071C103.444 142.764 101.075 144.738 98.3819 144.738H32.2569L156.601 269.081L280.944 144.738H219.564C217.033 144.738 214.819 142.998 214.106 140.545Z",
    fill: "#F0573E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.26271371fcc39756b50c965d56a84994.svg";
export { ForwardRef as ReactComponent };